module.exports = __webpack_public_path__ + "static/media/child-profile-stats.2b284e77.svg";